<template>
  <div class="article-list">
    <div class="container">
      <template v-if="!fallback">
        <div v-for="(article, index) in articleList" :key="article.id" class="article-item-container">
          <RouterLink :to="{ name: routeName, params: { locale: $i18n.localePath(), id: article.id }}"
                      :title="article.subject" class="article-item" @click.native="linkOnClick(article)"
          >
            <div class="subject">
              <slot name="subject">
                <span v-html="article.subject" />
              </slot>
            </div>
            <div class="info">
              <slot name="info" :article="article" />
            </div>
            <div class="content">
              <slot name="content">
                <span v-html="article.content + ' ...'" />
              </slot>
            </div>
          </RouterLink>
          <div v-if="showAdvertisement && (index + 1) % 10 === 0 || (index + 1) === articleList.length" class="pgnnp-item">
            <Paganiniplus />
          </div>
        </div>
      </template>
      <template v-else>
        <div v-for="(article, index) in articleList" :key="article.id" class="article-item-container">
          <a :href="articleResultURL(article)" target="_blank" rel="noopener noreferrer" class="article-item" @click.native="linkOnClick(article)">
            <div class="subject" v-html="article.subject" />
            <div v-if="type === 'articles'" class="content" v-html="article.content + ' ...'" />
            <div v-else class="content" v-html="displayArticlePrefix(article) + article.content + ' ...'" />
          </a>
          <div v-if="showAdvertisement && (index + 1) % 10 === 0 || (index + 1) === articleList.length" class="pgnnp-item">
            <Paganiniplus />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Paganiniplus from '@/components/tsp/Paganiniplus'
import LoggerService from '@/assets/services/LoggerService'

export default {
  name: 'SearchArticleList',
  components: {
    Paganiniplus
  },
  props: {
    articleList: {
      type: Array,
      required: true
    },
    showAdvertisement: {
      type: Boolean,
      default: false
    },
    fallback: {
      type: Boolean,
      default: false
    },
    periodicalArticles: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      type: this.periodicalArticles ? 'periodicalArticles' : 'articles',
      routeName: this.periodicalArticles ? 'periodicalArticleById' : 'articleById'
    }
  },
  methods: {
    articleResultURL(result) {
      return (this.$production.toUpperCase() === 'READ')
        ? `/${this.$i18n.localePath()}/${this.type}/${result.id}`
        : `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/${this.type}/${result.id}`
    },
    displayArticlePrefix(article) {
      if (article) {
        const title = article['periodical_title'] || ''
        const dateAry = article['periodical_volume_publication_date'] ? article['periodical_volume_publication_date'].split('-') : []
        const date = dateAry.length > 0 ? `${dateAry[0]}-${dateAry[1]}` : ''
        const volume = article['periodical_volume']
          ? ' (' + this.$t('READ.PERIODICAL_VOLUME_NUM', { volume: article['periodical_volume'] }) + ') '
          : ''
        return `${title} ${date} ${volume} `
      }
      return ''
    },
    linkOnClick(result) {
      const url = `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/${this.type}/${result.id}`
      this.logRecord(result, url)
    },
    logRecord(result, url) {
      const params = {
        userId: this.$store.getters.getProfile.id || '',
        peopleCookieId: window.localStorage.getItem('fingerprint') || '',
        refer: document.referrer || this.$route.query.refer || '',
        keyword: this.keyword,
        clickUrl: url,
        agent: window.navigator.userAgent
      }
      LoggerService.logUserSearchAction(params)
      const searchItemData = `[article] ${result.subject.replace(/(<([^>]+)>)/ig, '')} ${result.id}`
      // gtag event
      this.$store.dispatch('GTAG_EVENT', {
        action: 'view_search_results',
        data: { 'search_term': searchItemData }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.article-list {
  .article-item {
    width: calc(50% - 48px);
    float: left;
    margin: 0 24px 36px 0;
    cursor: pointer;
    text-decoration: none;
    .subject {
      position: relative;
      // height: 54px;
      margin-bottom: 8px;
      font-size: 24px;
      font-weight: 500;
      line-height: 1.63;
      color: $grey-50;
      width: 100%;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .info{
      font-size: 16px;
      font-weight: bold;
      line-height: 1.63;
      color: $grey-9b;
      max-height: 28px;
      @include ellipsis-with-lines(1);
    }
    .content {
      position: relative;
      height: 78px;
      font-size: 16px;
      font-weight: 500;
      line-height: 1.63;
      color: $grey-9b;
      @include ellipsis-with-lines(3);
    }
  }
  .pgnnp-item {
    margin: 0 auto 36px;
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  .article-list {
    .article-item {
      width: calc(100% - 48px);
      margin-bottom: 24px;
    }
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .article-list {
    .article-item {
      width: calc(100% - 48px);
      margin-bottom: 24px;
      .subject {
        height: calc(20px * 1.6);
        font-size: 20px;
        line-height: 1.6
      }
      .content {
        height: calc(14px * 1.64 * 3);
        font-size: 14px;
        line-height: 1.64
      }
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .article-list {
    .article-item {
      width: calc(100% - 48px);
      margin-bottom: 24px;
      .subject {
        height: calc(20px * 1.6);
        font-size: 20px;
        line-height: 1.6
      }
      .content {
        height: calc(14px * 1.64 * 3);
        font-size: 14px;
        line-height: 1.64
      }
    }
  }
}
</style>
